/**
 * Created by Amit
 */

///<reference path="../../node_modules/@nolimitcity/slot-game/lib/gsap/src/CustomBounce.d.ts"/>
///<reference path="../../node_modules/@nolimitcity/slot-game/lib/gsap/src/CustomEase.d.ts"/>

import {SlotGame} from "@nolimitcity/slot-game/bin/core/SlotGame";
import {SpacierArcadeGameModuleConfig} from "./SpacierArcadeGameModuleConfig";
import {GameModuleConfig} from "@nolimitcity/slot-game/bin/core/gamemoduleconfig/GameModuleConfig";
import {Reels} from "@nolimitcity/slot-game/bin/core/reel/reelarea/Reels";
import {TimelineReelsController} from "@nolimitcity/slot-game/bin/timelinegameround/reels/TimelineReelsController";
import {GameRoundManager} from "@nolimitcity/slot-game/bin/timelinegameround/core/gameround/GameRoundManager";
import {SAWinFieldController} from "./winpresentation/SAWinFieldController";

export class SpacierArcade extends SlotGame {
    public static timelineReelsController:TimelineReelsController;
    private static gameRoundManager:GameRoundManager;
    constructor() {
        super(SpacierArcadeGameModuleConfig.instance);
    }

    protected initGame():void {
        if (GameModuleConfig.instance.GAME_ROUND_CONFIG) {
            Reels.init();
            SpacierArcade.timelineReelsController = TimelineReelsController.instance;
            SpacierArcade.gameRoundManager = new GameRoundManager(GameModuleConfig.instance.GAME_ROUND_CONFIG());
        }
        else {
            super.initGame();
        }
    }

    protected createWinFieldController(): SAWinFieldController {
        return new SAWinFieldController();
    }

    getNoWinGameData():any {
        return {
            "reels": [
                [
                    "M2",
                    "L2",
                    "M4",
                    "L4",
                    "M3",
                    "L2",
                    "M2"
                ],
                [
                    "M2",
                    "L2",
                    "M4",
                    "L3",
                    "L2",
                    "M2",
                    "L2"
                ],
                [
                    "M3",
                    "L1",
                    "L3",
                    "M1",
                    "L3",
                    "M3",
                    "L1"
                ],
                [
                    "L3",
                    "M2",
                    "L3",
                    "M4",
                    "L1",
                    "L4",
                    "L4"
                ],
                [
                    "M1",
                    "L4",
                    "M3",
                    "L1",
                    "L2",
                    "L3",
                    "M1"
                ]
            ],
            "evaluatedReels": [
                [
                    "L4",
                    "M3",
                    "L2"
                ],
                [
                    "L3",
                    "L2",
                    "M2"
                ],
                [
                    "M1",
                    "L3",
                    "M3"
                ],
                [
                    "M4",
                    "L1",
                    "L4"
                ],
                [
                    "L1",
                    "L2",
                    "L3"
                ]
            ],
            "betWayWins": [],
            "totalSpinWinnings": 0,
            "totalSpinWinningsNotMultiplied": 0,
            "accumulatedRoundWin": 0,
            "playedBetValue": 1,
            "mode": "NORMAL",
            "nextMode": "NORMAL",
            "respinTriggeredThisSpin": false,
            "numberOfRespinPlayed": 0,
            "wildPositions": [
                -1,
                -1,
                -1,
                -1,
                -1
            ],
            "nudgeForNextSpin": [
                false,
                false,
                false,
                false,
                false
            ],
            "reelsNextSpin": "BASE_REELSET",
            "nearWinReels": [
                false,
                false,
                false,
                false,
                false
            ],
            "payoutMultiplier": 1,
            "payoutMultiplierNext": 1,
            "winPositions": [
                [
                    false,
                    false,
                    false,
                    false,
                    false
                ],
                [
                    false,
                    false,
                    false,
                    false,
                    false
                ],
                [
                    false,
                    false,
                    false,
                    false,
                    false
                ],
                [
                    false,
                    false,
                    false,
                    false,
                    false
                ],
                [
                    false,
                    false,
                    false,
                    false,
                    false
                ]
            ],
            "numberOfWinWays": 243,
            "numberOfWinWaysNextSpin": 243,
            "nbrOfRows": 3,
            "nbrOfRowsNextSpin": 3,
            "freespinPlayed": 0,
            "freespinsLeft": 0,
            "numberOfScatters": 0,
            "scatterPositions": [
                -1,
                -1,
                -1,
                -1,
                -1
            ],
            "freespinRetriggered": false,
            "freespinTriggeredThisSpin": false,
            "numberOfExtraFreespinsAwarded": 0,
            "reelsEnteringFreespin": [
                [
                    "X",
                    "X",
                    "X",
                    "X",
                    "X",
                    "X",
                    "X"
                ],
                [
                    "X",
                    "X",
                    "X",
                    "X",
                    "X",
                    "X",
                    "X"
                ],
                [
                    "X",
                    "X",
                    "X",
                    "X",
                    "X",
                    "X",
                    "X"
                ],
                [
                    "X",
                    "X",
                    "X",
                    "X",
                    "X",
                    "X",
                    "X"
                ],
                [
                    "X",
                    "X",
                    "X",
                    "X",
                    "X",
                    "X",
                    "X"
                ]
            ],
            "overlaySymbolsBeforeSpin": [
                [
                    null,
                    null,
                    null,
                    null,
                    null
                ],
                [
                    null,
                    null,
                    null,
                    null,
                    null
                ],
                [
                    null,
                    null,
                    null,
                    null,
                    null
                ],
                [
                    null,
                    null,
                    null,
                    null,
                    null
                ],
                [
                    null,
                    null,
                    null,
                    null,
                    null
                ]
            ],
            "overlaySymbolsAfterSpin": [
                [
                    null,
                    null,
                    null,
                    null,
                    null
                ],
                [
                    null,
                    null,
                    null,
                    null,
                    null
                ],
                [
                    null,
                    null,
                    null,
                    null,
                    null
                ],
                [
                    null,
                    null,
                    null,
                    null,
                    null
                ],
                [
                    null,
                    null,
                    null,
                    null,
                    null
                ]
            ],
            "newOverlaySymbols": [
                [
                    null,
                    null,
                    null,
                    null,
                    null
                ],
                [
                    null,
                    null,
                    null,
                    null,
                    null
                ],
                [
                    null,
                    null,
                    null,
                    null,
                    null
                ],
                [
                    null,
                    null,
                    null,
                    null,
                    null
                ],
                [
                    null,
                    null,
                    null,
                    null,
                    null
                ]
            ],
            "overlayWilds": [
                [
                    false,
                    false,
                    false,
                    false,
                    false
                ],
                [
                    false,
                    false,
                    false,
                    false,
                    false
                ],
                [
                    false,
                    false,
                    false,
                    false,
                    false
                ],
                [
                    false,
                    false,
                    false,
                    false,
                    false
                ],
                [
                    false,
                    false,
                    false,
                    false,
                    false
                ]
            ],
            "overlayWildsMultipliers": [
                [
                    0,
                    0,
                    0,
                    0,
                    0
                ],
                [
                    0,
                    0,
                    0,
                    0,
                    0
                ],
                [
                    0,
                    0,
                    0,
                    0,
                    0
                ],
                [
                    0,
                    0,
                    0,
                    0,
                    0
                ],
                [
                    0,
                    0,
                    0,
                    0,
                    0
                ]
            ],
            "overlayWildsNextSpin": [
                [
                    false,
                    false,
                    false,
                    false,
                    false
                ],
                [
                    false,
                    false,
                    false,
                    false,
                    false
                ],
                [
                    false,
                    false,
                    false,
                    false,
                    false
                ],
                [
                    false,
                    false,
                    false,
                    false,
                    false
                ],
                [
                    false,
                    false,
                    false,
                    false,
                    false
                ]
            ],
            "overlayWildsMultipliersNextSpin": [
                [
                    0,
                    0,
                    0,
                    0,
                    0
                ],
                [
                    0,
                    0,
                    0,
                    0,
                    0
                ],
                [
                    0,
                    0,
                    0,
                    0,
                    0
                ],
                [
                    0,
                    0,
                    0,
                    0,
                    0
                ],
                [
                    0,
                    0,
                    0,
                    0,
                    0
                ]
            ],
            "fsWildOnReelExcitement": [
                false,
                false,
                false,
                false,
                false
            ],
            "fsWildPosition": [
                -1,
                -1
            ],
            "fsWildPositions": [],
            "featureBuyTimesBetValue": [
                {
                    "name": "FREESPIN",
                    "type": "FREESPIN",
                    "price": 38
                }
            ],
            "featureBet": false,
            "wasFeatureBuy": false,
            "totalWinWaysWon": 0,
            "spinIntensity": -1
        };
    }
}